import { apiConfig } from './config.api';
import { axiosWithHeaders } from '@innovyze/lib_get_service';
import axiosRetry from 'axios-retry';

const iliData = axiosWithHeaders({
  service: 'iliManagement',
  config: apiConfig,
  axiosCreateOpts: {
    timeout: 10000,
  },
});

axiosRetry(iliData, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 500;
  },
});

export default iliData;
